module.exports = __webpack_public_path__ + "img/set-compensation.ddc106c3.png";